<template>
  <v-dialog v-model="visible" max-width="638" persistent>
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          :disabled="isLoading"
          @click.native="close(null)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4 pt-0 pb-5" v-html="$t(`${namespace}.text`)" />

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer/>

        <a
          v-if="!isLoading"
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="close(null)"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          color="accent"
          depressed
          round
          @click.native="handleReprocessAllDeclinedInvoices"
        >
          {{ $t('Common.proceed') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ReprocessAllDeclinedInvoicesDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object
    },
    filters: {
      type: Object
    }
  },
  data () {
    return {
      namespace: 'Views.ManualRetrieval.dialog',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    close (reload = null) {
      this.$emit('close', reload)
    },

    async handleReprocessAllDeclinedInvoices () {
      this.isLoading = true

      try {
        const { companyId, startDate, endDate } = this.filters
        const companyIds = companyId ? [String(companyId)] : []

        await this.$apiService.reprocessCreditCardInvoiceByPeriod({
          companyIds,
          startDate: startDate ? `${startDate}T23:59:59-0300` : null,
          endDate: endDate ? `${endDate}T00:00:00-0300` : null
        })

        this.showAlert({
          type: 'success',
          message: this.$t(`${this.namespace}.successMessage`)
        })

        this.close(true)
      } catch (err) {
        console.log('ERROR:', err)
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.errorMessage`)
        })
      }

      this.isLoading = false
    }
  }
}
</script>
